import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionList.module.scss";

type Props = {
	docType: "billing" | "estimation";
	fee: number;
	feeTitle: string;
	showButtons?: boolean;
	showSwitchEnable?: boolean;
};

export function FeeRow({
	docType,
	fee,
	showButtons = false,
	showSwitchEnable = false,
	feeTitle
}: Props) {
	return (
		<tr className={Styles.ListRow}>
			<td className={Styles.OrderHandle} />
			{showSwitchEnable ? <td className={Styles.SwitchEnable} /> : null}
			{docType === "estimation" ? (
				<td className={Styles.EstimationType} />
			) : null}
			<td className={Styles.Estimation}>
				<div className={Styles.Point}>{feeTitle}</div>
			</td>
			<td className={Styles.UnitAmount} />
			<td className={Styles.ChargePer} />
			<td className={Styles.Amount}>¥{toThousandSeparator(fee)}</td>
			{showButtons ? <td className={Styles.Buttons} /> : null}
		</tr>
	);
}
